import { VideoConference } from '@livekit/components-react';

/**
 * In-room chrome. Lives in its own module so App re-renders do not remount
 * the conference. Layout is owned entirely by room.css — no inline heights
 * here, because an inline height:100% alongside safe-area padding was
 * overflowing the shell and pushing the control bar (and the chat toggle
 * with it) off the bottom of the screen.
 */
export default function RoomContent() {
  return (
    <div className="room-container" data-layout-stage="5">
      <VideoConference chatMessageFormatter={undefined} />
    </div>
  );
}
